<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 pt-8 min-h-screen px-4">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700" @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto max-w-6xl bg-white p-8 rounded-lg shadow-lg ">

        <h1 class="font-bold text-center text-2xl">Acreditación de invitados</h1>
        <h1 class="font-bold text-center text-xl">Por favor complete el formulario</h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Documento</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Documento" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field,errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Apellido" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Empresa</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Empresa" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="empresa" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Actividad / Ocupación</label>
            <Field name="ocupacion" v-slot="{ field,errors }" v-model="formData.ocupacion">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Actividad / Ocupación" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="ocupacion" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
              <label class="block mb-1">País</label>
              <Select v-model="selectedCountry" filter :options="paises" optionLabel="value" placeholder="Select a Country" class="input-base"/>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Prefijo</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.code" class="input-base" readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Código de área" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono</label>
            <Field name="numeroTelefono" v-slot="{ field, errors }" v-model="formData.numeroTelefono">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Teléfono" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="numeroTelefono" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-8/12">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="input-base" placeholder="Mail" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Código de invitación</label>
            <Field name="codigoInvitacion" v-slot="{ field, errors }" v-model="formData.codigoInvitacion">
              <InputText v-bind="field" type="mail" class="input-base" placeholder="Código de invitación" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoInvitacion" /></span>
            </Field>
          </div>
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
          <div class="w-full px-2 flex flex-row gap-2">
            <ToggleSwitch v-model="formData.recibirNodedades" inputId="recibirNotificaciones" />
            <label for="recibirNotificaciones" class="cursor-pointer">Acepto recibir información y novedades de Nacionales 2026</label>
          </div>
        </div>        

        <div class="flex flex-wrap py-2 mt-3 jusi">
          <button type="submit" label="REGISTRARME"
            class="mt-8 px-4 py-2 bg-transparent border-blue-950 hover:bg-cyan-600 text-blue-950 font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i> REGISTRARME
          </button>
        </div>
      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />
      
    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import BlockUI from 'primevue/blockui';
import HeaderSection from '@/components/HeaderSection.vue'
import ToggleSwitch from 'primevue/toggleswitch';

import jsonCountries from '@/data/countries.json';

import suiteService, { Acreditado, EstadoAcreditado, OrigenAcreditado, TipoAcreditado } from 'qreventos-suite/services';
import invitacionService, { Invitacion } from 'qreventos-suite/invitaciones';

import {  SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';

interface Pais {
  code: string;
  value: string;
}

export default defineComponent({
  name: 'FormSection',
  components: {
    HeaderSection,
    InputText, Select, ToggleSwitch,
    Field, ErrorMessage, Form, BlockUI
  },
  data() {
    return {
      isSubmitting: false,
      paises: jsonCountries as Pais[],
      selectedCountry: {"code": "+54", "value": "Argentina"} as Pais,
      formData: {     
        dni: '',
        nombre: '',
        apellido: '',
        empresa : '',
        ocupacion:'',
        mail: '',
        codigoArea: '',
        numeroTelefono: '',
        codigoInvitacion: '',
        recibirNodedades: true,
      }
    };
  }, 
  created () {
    document.title = "Nacionales Santander 2026";
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required("Ingrese el documento").min(6, "Al menos 6 caracteres"),
        nombre: yup.string().required("Ingrese el nombre").min(3, "Al menos 3 caracteres"),
        apellido: yup.string().required("Ingrese el apellido").min(3, "Al menos 3 caracteres"),
        empresa: yup.string().required("Ingrese la empresa").min(2, "Al menos 2 caracteres"),
        ocupacion: yup.string().required("Ingrese la ocupación").min(3, "Al menos 3 caracteres"),
        codigoArea: yup.string().required("Ingrese el código de área").matches(/^\d+$/, "Debe ser numérico"),
        numeroTelefono: yup.string().required("Ingrese el telefono").matches(/^\d+$/, "Debe ser numérico"),
        mail: yup.string().required("Ingrese el mail").email("Mail inválido"),
        codigoInvitacion: yup.string().required("Ingrese el código de invitación"),
      });
    },
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores:number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Hay errores", html: "Por favor revise el formulario (" + errores + "error/es)", icon: "error"});
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado[] =  await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni="+encodeURIComponent(this.formData.dni) ) ;
        if (acreditadoExistente.length > 0) {
            this.isSubmitting = false;
              Swal.fire({ title: "Atención",  html: "¡Ya estas acreditado!<br/><br/>Te enviamos un correo con tu credencial<br/><br/>Si no te llega el correo la podes descargar usando el botón <b>'YA ME ACREDITE'</b> de esta pagina.", icon: "warning" }).then(() => {
                  this.isSubmitting = false;
              });
              return;
        }

        let invitacion:Invitacion = await invitacionService.findInvitacionBy(suiteConfig.evento, this.formData.codigoInvitacion);
        console.log(invitacion);
        console.log(this.formData.codigoInvitacion);
        console.log(suiteConfig.evento);
        
        if(!invitacion) {
          this.isSubmitting = false;
          Swal.fire({ title: "¡Atención!", html: "El código de invitación ingresado no existe", icon: "error"});
          return;
        }

        const acreditado:Acreditado = {} as Acreditado;
        
        acreditado.tipoAcreditado = { "id" : 2233 } as TipoAcreditado,
        acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
        acreditado.origenAcreditado = { "id" : ORIGEN_ACREDITADO } as OrigenAcreditado;
        acreditado.dni = this.formData.dni;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;
        acreditado.empresa = this.formData.empresa;
        acreditado.dato1 = this.formData.ocupacion;
        acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.numeroTelefono;
        acreditado.mail = this.formData.mail;
        acreditado.invitacion = invitacion;

        if(this.formData.recibirNodedades) {
          acreditado.dato2 = "SI";
        } else {
          acreditado.dato2 = "NO";
        }

        acreditado.cantidad = 1;
        acreditado.notificar = true;
        acreditado.modificado = SAVE;

        const acreditadoActualizado: Acreditado = await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

    
        if (acreditadoActualizado) {
          this.isSubmitting = false;
          Swal.fire({ title: "Atención",  html: "Ya estas acreditado<br/>Te enviamos un correo con tu credencial<br/>Si no te llega el correo la podes descargar usando el botón <b>'YA ME ACREDITE'</b> de esta pagina", icon: "info" }).then(() => {
            this.$router.go(0);
          });
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
  }
});
</script>